export const LIST_WITH_COURSES_AND_INTERNSHIPS_PAGE = "/vse-ayti-kursy-i-stajirovki-ot-ayti-kompaniy";
export const LANGUAGES_TOP_PAGE = '/languages-top';